import React, {
  ChangeEventHandler,
  FocusEventHandler,
  HTMLInputTypeAttribute,
  MutableRefObject,
} from "react";
import { FormikErrors, FormikTouched } from "formik";

interface BYInputProps<T> {
  type: HTMLInputTypeAttribute | "textarea";
  name?: string;
  placeholder?: string;
  title?: string;
  disabled?: boolean;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  onChange?: ChangeEventHandler<T> | undefined;
  value?: string | ReadonlyArray<string> | number | undefined;
  required?: boolean;
  className?: string;
  helpMessage?: string;
  autoComplete?: string;
  accept?: string;
  onBlur?: FocusEventHandler<T> | undefined;
  autoFocus?: boolean | undefined;
  rows?: number;
  inputRef?: MutableRefObject<T>;
}

export const BYInput = (props: BYInputProps<any>) => {
  const {
    type,
    name,
    placeholder,
    touched,
    error,
    value,
    title,
    disabled,
    onBlur,
    onChange,
    autoFocus,
    required,
    autoComplete,
    rows = 3,
    accept,
    inputRef,
    helpMessage,
  } = props;

  const displayError = touched && error;
  const isTextArea = type === "textarea";

  return (
    <>
      {title && <label className="form-label">{title}</label>}
      {!isTextArea && (
        <input
          ref={inputRef}
          type={type}
          name={name}
          accept={accept}
          placeholder={placeholder}
          className={`form-control ${displayError ? "has-error" : ""}`}
          disabled={disabled}
          autoComplete={autoComplete}
          value={value || ""}
          onBlur={onBlur}
          onChange={onChange}
          required={required}
          autoFocus={autoFocus}
        />
      )}
      {isTextArea && (
        <textarea
          ref={inputRef}
          name={name}
          placeholder={placeholder}
          className={`form-control ${displayError ? "has-error" : ""}`}
          disabled={disabled}
          autoComplete={autoComplete}
          value={value || ""}
          onBlur={onBlur}
          onChange={onChange}
          required={required}
          autoFocus={autoFocus}
          rows={rows}
          maxLength={
            placeholder === "Commentaire interne"
              ? 500
              : 50000
          }
        />
      )}
      {displayError && (
        <div className="text-danger font-weight-bold">{error}</div>
      )}
      {!!helpMessage && <div className="form-text">{helpMessage}</div>}
    </>
  );
};
